import { combineEpics } from 'redux-observable';
import { loadServicePrincipalNameListEpicReducer } from '../ducks/ServicePrincipalList.ducks';
export default combineEpics(loadServicePrincipalNameListEpicReducer.epic);

//# sourceMappingURL=ServicePrincipalListEpic.js.map
